export default __webpack_public_path__ + "static/marine-283e3c207b5db0b83a1d0aa5463f3bb5.jpg";